{
    "TeamsAuth_UserIntro": "Hi {},",
    "TeamsAuth_UserIntro_2": "O Akixi for MS Teams está a solicitar acesso ao seu Microsoft Entra Tenant",
    "TeamsAuth_AdminConsent": "Autorização do administrador da concessão",
    "TeamsAuth_Authorise": "Autorizar",
    "TeamsAuth_ConsentedMessage": "Autorização de administração concedida, clique em Autorizar para continuar",
    "TeamsAuth_AuthorisedMessage": "Autorização concedida",
    "TeamsAuth_Decline": "Declínio",
    "TeamsAuth_Error_Unknown": "Ocorreu um erro não reconhecido. Tente novamente. Se o problema persistir, contacte o administrador do sistema.",
    "NAME": "TeamsAuth"
}